import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	form: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(2),
		"& .mco-form-input, & .mco-form-select": {
			flex: "0 0 100% !important"
		}
	},
	button: {
		display: "flex",
		flex: "0 0 100%",
		gap: theme.spacing(1),
		justifyContent: "flex-end",
		marginTop: theme.spacing(2),
		"& .mco-form-button-wrapper": {
			flex: "none"
		}
	}
}));

export default styles;
